import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
export default {
  attributeName: 'device-types',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You haven't created any device types yet. Click \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the type',
      canEdit: true,
      canFilter: true,
      canCreate: true,
      canOrder: true,
      width: '12rem',
    },
    {
      attributeName: 'code',
      label: 'Code',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The code of the type',
      canEdit: false,
      canFilter: true,
      canCreate: true,
      canOrder: true,
      width: '12rem',
    },
    {
      attributeName: 'platform',
      label: 'Platform',
      type: FormInputTypes.SELECT,
      helpText: 'Device platform',
      canEdit: true,
      canFilter: true,
      canCreate: true,
      canOrder: true,
      width: '12rem',
      emptyValue: true,
      default: 'default',
      options: [
        { name: 'Quest', value: 'quest' },
        { name: 'Android', value: 'android' },
        { name: 'Android XR', value: 'androidXR' },
        { name: 'iOS', value: 'ios' },
        { name: 'VisionOS', value: 'visionOS' },
        { name: 'Others', value: 'others' },
      ],
      filterSelectOptions: [
        { name: 'Type filter...', value: 'no-filter'},
        { name: 'Quest', value: 'quest' },
        { name: 'Android', value: 'android' },
        { name: 'Android XR', value: 'androidXR' },
        { name: 'IOS', value: 'ios' },
        { name: 'VisionOS', value: 'visionOS' },
        { name: 'Others', value: 'others' },
      ],
    }
  ],
};
